import styled from 'styled-components';
import { colors } from '../../../utils/colors';

export const Container = styled.div`
  & > :last-child .col .MuiPaper-root {
    border-bottom-width: 1px !important;
  }
`;
